import { RangeSlider } from 'flowbite-react';
import React, { FC, useState, useRef, useEffect, useCallback } from 'react';
import ReactCrop, { Crop, PixelCrop } from 'react-image-crop';
import { canvasPreview } from './utils';
import Button from '../button/button';
import Text from '../text/text';

interface IProps {
    imgSrc: string;
    close: () => void;
    save: (dataURL: string) => void;
    title: string;
    text: string;
    aspectCrop?: number;
    inicialCorp?: Crop;
}

const Cropper: FC<IProps> = ({ imgSrc, close, save, title, text, aspectCrop, inicialCorp }) => {
    const previewCanvasRef = useRef<HTMLCanvasElement>(null);
    const imgRef = useRef<HTMLImageElement>(null);
    const [crop, setCrop] = useState<Crop>();
    const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
    const [scale, setScale] = useState(1);
    const [sliderValue, setSliderValue] = useState(1);
    const [aspect, setAspect] = useState<number | undefined>(aspectCrop || undefined);

    const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
        const { width, height } = e.currentTarget;
        if (inicialCorp) {
            const inicialWidth = inicialCorp.width < width ? inicialCorp.width : width;
            const inicialHeight = inicialCorp.height < height ? inicialCorp.height : height;
            setCrop({
                width: Math.min(inicialWidth, inicialHeight),
                height: Math.min(inicialWidth, inicialHeight),
                unit: inicialCorp.unit,
                x: inicialCorp.x,
                y: inicialCorp.y,
            });
        }
    };
    const fn = useCallback(async () => {
        if (completedCrop?.width && completedCrop?.height && imgRef.current && previewCanvasRef.current) {
            canvasPreview(imgRef.current, previewCanvasRef.current, completedCrop, scale);
        }
    }, [completedCrop, scale]);

    useEffect(() => {
        const t = setTimeout(() => {
            return fn();
        }, 100);

        return () => {
            clearTimeout(t);
        };
    }, [fn]);
    const handleSave = async () => {
        setCrop(undefined);
        save(previewCanvasRef.current?.toDataURL('image/png') as string);
    };

    useEffect(() => {
        setScale(parseFloat(sliderValue.toString()) || 1);
    }, [sliderValue]);

    return (
        <div className="fixed top-0 right-0 bottom-0 left-0 font-roboto inset-0  bg-transparent-black z-[90] h-screen overflow-y-auto">
            <div className="w-screen overflow-y-auto h-screen flex items-start justify-center p-10">
                <div className="bg-white p-4 rounded-lg shadow-lg max-w-[410px] w-full text-start">
                    <Text className="mb-2 font-semibold uppercase">{title}</Text>
                    {Boolean(imgSrc) && (
                        <div>
                            <ReactCrop
                                crop={crop}
                                onChange={(_, percentCrop) => setCrop(percentCrop)}
                                onComplete={(c) => setCompletedCrop(c)}
                                aspect={aspectCrop || aspect}
                            >
                                <img
                                    ref={imgRef}
                                    id="img"
                                    alt="Crop me"
                                    src={imgSrc}
                                    style={{ transform: `scale(${scale})` }}
                                    onLoad={onImageLoad}
                                />
                            </ReactCrop>
                        </div>
                    )}
                    <div className="Crop-Controls">
                        <RangeSlider
                            id="slider"
                            min={1}
                            max={2}
                            step={0.2}
                            defaultValue={1}
                            sizing="sm"
                            onChange={(event) => {
                                setSliderValue(parseFloat(event.target.value));
                                setAspect(1 * (parseFloat(event.target.value) || 1));
                            }}
                        />
                    </div>
                    <div>
                        <Text className="mt-10 mb-3 text-center w-full font-semibold">{text}</Text>
                        <div>{completedCrop && <canvas ref={previewCanvasRef} className="w-1/2 mx-auto mb-10" />}</div>
                    </div>
                    <div className="flex justify-end mt-6">
                        <Button
                            type="button"
                            size="lg"
                            label={'Cancelar'}
                            variant="outlined"
                            onClick={close}
                            className="mr-2 bg-transparent"
                        />
                        <Button
                            type="button"
                            className="font-poppins text-sm font-semibold"
                            size="lg"
                            label={'Guardar'}
                            color="variant"
                            onClick={handleSave}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cropper;
